<div class="modal-header">
    <h4 class="modal-title">
        <i data-feather="alert-circle"></i> {{data.title}}
    </h4>

</div>
<div class="modal-body">
    <p [innerHTML]="data.message"></p>

    <form [formGroup]="customerConfirmMailForm" class="w-100">
        <div class="d-flex flex-column align-items-center w-100 mt-2">

            <button type="button" class="btn btn-outline-success btn-sm mb-2" (click)="changeCode()">
                Bir Kodum Var
            </button>

            <input *ngIf="isRequiredCode" type="text" class="form-control w-75" id="code" formControlName="code"
                placeholder="Kod giriniz" />
        </div>
    </form>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-danger" (click)="closeModal({id:1,code:null})">Hayır</button>
    <button type="button" class="btn btn-success" (click)="closeModal(
      isRequiredCode
        ? { id: 2, code: customerConfirmMailForm.get('code').value }
        : { id: 3, code: null }
    )" [disabled]="isRequiredCode && customerConfirmMailForm.invalid">
        Evet
    </button>

</div>